/**
 * 統合系 API が 409 で返す理由コード。
 * Mypage API の spec (spec/routes/accounts/main.tsp) が宣言する literal と対応する。
 */
export const IntegrationConflictCode = {
  /** 統合先アカウントのメールアドレスが保護者メールアドレスと重複している */
  GuarantorEmailConflict: 'guarantor_email_conflict',
  /** 既にサブメールアドレスが登録済みのアカウントに対する統合操作 */
  AccountAlreadyIntegrated: 'account_already_integrated',
} as const;

export type IntegrationConflictCodeValue = (typeof IntegrationConflictCode)[keyof typeof IntegrationConflictCode];

/**
 * 409 応答のボディから理由コードを取り出す。
 * 理由コードを付与していない Mypage API からの応答も受け取りうるため、
 * 読み取れない場合は従来どおり保護者メール重複として扱う。
 */
export function extractConflictCode(error: unknown): IntegrationConflictCodeValue {
  if (typeof error === 'object' && error !== null && 'code' in error) {
    const { code } = error as { code: unknown };
    if (code === IntegrationConflictCode.AccountAlreadyIntegrated) {
      return IntegrationConflictCode.AccountAlreadyIntegrated;
    }
  }
  return IntegrationConflictCode.GuarantorEmailConflict;
}
